export const MAIN_THEME = {
  color: { link: "#a9a9a9", main: "#000000" },
  spacing: {
    s: "0.25rem",
    s2: "0.4rem",
    m: "0.5rem",
    m2: "0.75rem",
    l: "1rem",
    xl: "2rem",
    xl2: "4rem",
    xl3: "6rem",
    xl4: "8rem",
  },
  font: {
    family: { link: "Verdana", main: "Verdana. Arial" },
    size: { small: "0.8rem", normal: "1rem" },
    weight: { normal: "normal", bold: 700 },
  },
};
